<div class="row justify-content-end" style="background-color: #fff;border-top:1px solid #ccc;margin:0px; height:56px; margin-bottom:-50px;">
  <div class="col-md-auto">
    <button style="float:left; margin:10px;" class="btn btn-warning" (click)="fsc.close()">Cancel</button>
    <button style="float:left; margin:10px;" class="btn btn-primary" (click)="fsc.close()">Select Files</button>
  </div>
</div>
